import { useQuery } from "@tanstack/react-query";
import { getPosts } from "../../../api/apiBlog";
import i18next from "i18next";

export const useGetPosts = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["posts", params, i18next.language],
        queryFn: () => getPosts(params),
        keepPreviousData: true,
    });

    return {
        posts: data?.data || [],
        meta: data?.meta,
        isLoading,
        error,
        refetch,
    };
};
